<template>
  <div class="noData">
    <indexHeader></indexHeader>
    <div class="headerContent">
      <div class="tips">抱歉，我们有的都在这儿了</div>
      <div class="tip1" @click="turnPath">立即收录</div>
    </div>

    <a-card
      class="card"
      :bodyStyle="{ maxHeight: '420px', overflowY: 'auto' }"
      title="已收录关键词"
    >
      <a-card-grid
        v-for="list in hotWord"
        @click="chaxun(list.keyword)"
        :key="list"
        class="kuaigzi"
        style="width: 20%; text-align: center; cursor: pointer"
        >{{ list.keyword }}</a-card-grid
      >
    </a-card>
    <a-layout-footer style="text-align: center"> </a-layout-footer>
      <div class="hoverBottomWapper"> 
      <div class="hoverBottom1">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
    </div>
    </div>
  </div>
</template>

<script>
import indexHeader from '@/components/indexHeader'
import { getAllWordList, addHotKey } from '../../utils/api'
import { message } from 'ant-design-vue'
export default {
  components: {
    indexHeader
  },
  mounted () {
    this.getIndex()
  },
  data () {
    return {
      hotKey: this.$route.query.word,
      keyColumns: [
        {
          title: '关键词',
          dataIndex: 'title',
          sorter: (a, b) => a.keyword.localeCompare(b.keyword),
          key: 'title',
        },
      ],
      hotWord: [],
    }
  },
  methods: {
    async getIndex () {
      let that = this
      await getAllWordList().then(res => {
        if (res.total != 0) {
          that.hotWord = res.rows
        }
      })
    },
    turnPath () {
      addHotKey({ "keywords": this.hotKey }).then(res => {
        message.success('收录成功！')
        this.$router.push('indexList')
      })
      // this.$router.push('indexList')
    },
    chaxun (word) {
      console.log("跳转事件")
      this.$router.push({
        name: 'indexTool',
        query: {
          word: word,
          type: 0
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.noData {
  background-color: #333;
  min-height: 100vh;
  width: 100vw;
    .hoverBottomWapper{
    width: 100%;
    background-color: #333;
    padding-bottom: 10px;
    .hoverBottom1{
      position: relative;
      width:100%;
      // text-align:center;
      //  padding:0px 0 10px 0;
      width:fit-content;
      margin: 0 auto;
      display: block;
      text-align:center;
       p>a{
          color: rgb(147, 147, 147);
           position: relative;
          padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
    }
  }
  /deep/.ant-card {
    width: 84.17%;
    margin: 31px auto 0 auto;
    border: 0;
    .ant-card-head {
      background-color: #000;
      color: #fff;
    }
  }
  /deep/.ant-layout-footer {
    background-color: #333;
  }
  /deep/.ant-card-grid {
    box-shadow: 1px 0 0 0 #d9d9d9, 0 1px 0 0 #d9d9d9, 1px 1px 0 0 #d9d9d9, 1px 0 0 0 #d9d9d9 inset,
      0 1px 0 0 #d9d9d9 inset;
    position: relative;
    &::after{
        content: "";
        display: block;
        height: auto;
        border-bottom: 0!important;
        background-image: linear-gradient(#00f000,#00f000);
        text-decoration: none;
        padding-bottom: 2px;
        background-position: 0 100%;
        background-repeat: no-repeat;
        background-size: 0 2px;
        transition: background-size .3s;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    &:hover{
        color: #00F000;
        // border-bottom: 1px solid #00F000;
        // background-size: 100% 2px
        &::after{
            background-size: 100% 2px
        }
    }
  }
  .headerContent {
    background-image: url(../../assets/image/ff.png);
    padding-top: 96px;
    padding-bottom: 61px;
    .tips {
      text-align: center;
      color: #fff;
      font-size: 34px;
      height: 34px;
      line-height: 34px;
      margin-bottom: 25px;
    }
    .tip1 {
      width: 150px;
      height: 40px;
      line-height: 40px;
      font-size: 26px;
      text-align: center;
      margin: 0 auto;
      background: #00f000;
      color: #1e1e1e;
      border-radius: 3px;
      font-weight: 500;
      cursor: pointer;
    }
  }

  .part {
    padding-left: 300px;
    font-size: 28px;
    margin-top: 30px;
    color: #333;
  }
  .table table thead,
  .table tbody tr {
    display: table;
    width: calc(100% - 1px);
    table-layout: fixed;
  }
  .table tbody {
    display: block;
    overflow-y: scroll;
    height: 400px;
  }
  .table tbody td {
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    text-indent: 10%;
    text-align: center;
    border: 1px solid #000;
  }
  .table {
    width: 1200px;
    margin-left: 300px;
    margin-top: 10px;
    border-collapse: collapse;
  }

  //     tbody{
  //         td{
  //             border: 1px solid #333;
  //             height: 40px;
  //             line-height: 40px;
  //             font-size: 18px;
  //             text-indent: 10%;
  //         }
  //     }
  // }
}
</style>